import { KEYWORDS } from '@racemap/utilities/consts/seo';
import { isEmptyString, isNotEmptyString } from '@racemap/utilities/functions/utils';
import { Helmet } from 'react-helmet';
import { getPreviewUrl } from 'src/lib/EventUtils';
import { getLeaderboardUrl } from 'src/lib/getLeaderboardUrl';
import { getPlayerUrl } from 'src/lib/getPlayerUrl';
import { useSelectedEventData } from 'src/store/leaderboard/leaderboard_reducer';
import { checkLeaderboardActivationState } from './utils';

export const LeaderboardHelmet = () => {
  const selectedEventData = useSelectedEventData();
  if (selectedEventData == null) return null;

  const selectedEvent = selectedEventData.eventObject;
  const previewUrl = getPreviewUrl(selectedEvent);
  const playerUrl = getPlayerUrl(selectedEvent);
  const selectedEventName = selectedEvent.name;
  const description = `Live Leaderboard for ${!isEmptyString(selectedEventName) ? selectedEventName : 'the event'}.
  Follow the event in real-time on ${playerUrl}.`;
  const activationState = checkLeaderboardActivationState(selectedEvent);
  const disableIndex =
    activationState.isArchived ||
    !activationState.isModuleActivated ||
    !activationState.isEventAuthorized;

  return (
    <Helmet>
      <title>{`Racemap | ${!isEmptyString(selectedEventName) ? selectedEventName : 'Leaderboard'}`}</title>
      <meta name="description" content={description} />
      <meta
        name="keywords"
        content={[selectedEventName, selectedEvent.location, 'leaderboard', ...KEYWORDS].join(', ')}
      />
      <meta
        property="og:title"
        content={`${isNotEmptyString(selectedEvent.name) ? `${selectedEvent.name} ` : ''}» Racemap`}
      />
      <meta name="robots" content={disableIndex ? 'noindex,nofollow' : 'index,follow'} />
      <meta property="og:type" content="website" />
      <meta property="og:image" content={`${previewUrl}?size=600x314&with_logo`} />
      <meta property="og:image:secure_url" content={`${previewUrl}?size=600x314&with_logo`} />
      <meta property="og:url" content={`${playerUrl}`} />
      <meta property="og:site_name" content="» Racemap | Leaderboard" />
      <meta property="fb:app_id" content="416276161749392" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:site" content="@racemap" />
      <meta
        name="twitter:title"
        content={`${isNotEmptyString(selectedEvent.name) ? `${selectedEvent.name} ` : ''}» Racemap`}
      />
      <meta name="twitter:description" content={`${description}`} />
      <meta name="twitter:image" content={`${previewUrl}?size=600x314&with_logo`} />
      <link rel="canonical" href={getLeaderboardUrl(selectedEvent)} />
    </Helmet>
  );
};
